import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { Facet } from 'engine/facets/Facet';
import { KinematicBodyFacet } from 'engine/facets/KinematicBodyFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { AudioManager } from 'engine/lib/AudioManager';
import { V2, scaleV2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { Hittable } from 'game/behaviors/Hittable';
import { CollisionLayer } from 'game/config';
import { createElement } from 'react';

// eslint-disable-next-line global-require
const laserSound = new AudioManager(require('game/sfx/laser.mp3'), { volume: 0.8 });

interface BulletEntityProps {
  velocity: V2,
  damage: number,
}

class BulletBehavior extends Facet<BulletEntityProps> {

  body = create(KinematicBodyFacet, {});

  collider = create(ColliderFacet, {
    type: ColliderType.Circle,
    offset: [-20, -20],
    radius: 20,
    trigger: true,
  });

  created = -1;

  audio = laserSound.clone();

  start(engine: Engine) {
    this.created = engine.time.now;
    this.entity.addFacet(this.body, engine);
    this.entity.addFacet(this.collider, engine);
    this.audio.play();
  }

  physicsUpdate(delta: number, engine: Engine) {
    this.body.move(scaleV2([...this.props.velocity], delta), engine);
    const hitbox = this.collider.collisions.find(c => c.props.layer && c.props.layer & CollisionLayer.Hitbox);
    if (hitbox) {
      const hitRes = hitbox.entity.getFacet(Hittable)?.props.hit(this.entity, engine);
      if (hitRes) engine.destroy(this.entity);
      return;
    }
    if (engine.time.now - this.created > 1500) {
      engine.destroy(this.entity);
    }
  }
}

export class BulletEntity extends Entity<BulletEntityProps> {
  createFacets(props: BulletEntityProps) {
    return [
      create(BulletBehavior, props),
      create(StaticSpriteFacet, {
        frame: createElement('circle', { r: 20, fill: 'white' }),
      }),
    ];
  }
}
